import checkAjaxError from '@ott/helper-check-ajax-error';
import superagent from '@ott/superagent';

import { createAsyncThunk } from '@reduxjs/toolkit';

import { STATUS_CODES, ERROR_CODES } from '../../../../constants';
import makeCustomerCareInfo from '../../helpers/customerCare';
import { authLoginResultEvent, userNotFoundEvent, wrongPasswordEvent } from '../../helpers/events';
import { AuthError, SuperagentError } from '../../types';
import { getBasicUserInfo } from '../getBasicUserInfo';
import { Payload, ResponseSuccess } from './types';

export const enter = createAsyncThunk<
  ResponseSuccess | undefined,
  Payload,
  { rejectValue: AuthError }
>('auth/enter/fetch', async ({ email, password, reqHost = '' }, { dispatch, rejectWithValue }) => {
  const data = { email, pwd: password };

  const url = `${reqHost}/_auth/authenticate/auth`;

  const customerInfo = makeCustomerCareInfo({
    url,
    params: data,
    step: 'auth',
  });

  try {
    const { body, status } = await superagent
      .post(url, { captchaMountContainer: 'auth-enter' })
      .type('form')
      .send(data)
      .withCredentials();

    if (body && body?.error) {
      return rejectWithValue({
        status,
        data: { ...body, customerInfo },
      });
    }

    dispatch(getBasicUserInfo({ reqHost }));
    authLoginResultEvent();

    return body as ResponseSuccess;
  } catch (e) {
    const err = e as SuperagentError;

    if ('response' in err) {
      if (err.response.body?.error === ERROR_CODES.INVALID_LOGIN) {
        userNotFoundEvent('Auth_Popup_Login_Result');
      } else if (err.response.body?.error === ERROR_CODES.INVALID_PASSWORD) {
        wrongPasswordEvent('Auth_Popup_Login_Result');
      }

      if (err && err.status === STATUS_CODES.UNAUTHORIZED) {
        return rejectWithValue({
          status: err.status,
          data: { ...err.response.body, customerInfo },
        });
      }

      return rejectWithValue({ data: checkAjaxError(err, customerInfo) });
    }
  }
});
